<template>
    <div>
        <div class="module-hero">
            <img :src="'../../static/'+ currentLocale +'/hero.jpg'" alt="" class="img-hero" >
        </div>
        <Page v-bind:pagedata="page" v-if="page != null" v-show="!pageLoading"></Page>
        <div class="container loader" v-show="pageLoading">
            <h2>Ladataan...</h2>
        </div>
    </div>
</template>
<script>
  import HeroStart from '@/views/components/HeroStart'
  import Page from './Page.vue'
  import secretStore from '../../utils/localstorage'

  export default {
    data: function () {
      return {
        pageLoading: false,
        page: null
      }
    },
    components: {
      HeroStart,
      Page
    },
    props: {
      pid: null,
      pids: [],
      colorclass: '',
      herosrc: ''
    },
    watch: {
      'pid': function (pid) {
        if (pid != null) {
          this.fetchPage()
        }
      }
    },
    created: function () {
      this.fetchPage()
    },
    methods: {
      fetchPage: function () {
        // console.log(this.pid)
        this.pageLoading = true
        var pageId = this.pid

        if(this.$route.params.locale == 'sv'){
            pageId = this.pids[1]
        }
        if(this.$route.params.locale == 'en'){
            pageId = this.pids[2]
        }

        this.axios.get('pages/' + pageId ).then((response) => {
          // console.log(response.data)
          this.page = response.data
          this.pageLoading = false
        })
      },
    },
    computed: {
        currentLocale() {
          return this.$route.params.locale
        },
    },
  }
</script>

<style scoped lang="scss">
    .loader {
        padding: 4em;
        text-align: center;

        h2 {
            font-size: 24px;
            color: #059DF3;
            font-weight: bold;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/components/ContentUnitSingle.vue